<template>
  <div class="mb-5 mt-8">
    <div class="font-bold">{{ t("collaborators.title") }}</div>
    <div class="text-medium-emphasis text-sm">
      {{ t("collaborators.description") }}
    </div>
  </div>
  <v-table density="compact" class="mt-4">
    <thead>
      <tr>
        <th class="text-left assigned-column">{{ t("collaborators.assigned") }}</th>
        <th class="text-left">{{ t("collaborators.email") }}</th>
      </tr>
    </thead>
    <v-skeleton-loader v-if="loading" type="table-thead, table-tbody"></v-skeleton-loader>
    <tbody>
      <tr v-for="user in users" :key="user.uid">
        <td class="assigned-column">
          <v-checkbox
            v-model="selected"
            color="primary"
            :value="user.uid"
            hide-details
            density="compact"
          ></v-checkbox>
        </td>
        <td>{{ user.email }}</td>
      </tr>
    </tbody>
  </v-table>
</template>

<script setup lang="ts">
import { useI18n } from "@/composables/useI18n";

const { t } = useI18n();
const selected = defineModel<string[]>({
  required: true,
});

defineProps<{
  users: { uid: string; email: string }[];
  loading: boolean;
}>();
</script>

<style scoped>
.assigned-column {
  width: 100px;
  max-width: 100px;
}
</style>
